<template>
  <div class="gift-board">
    <div class="gift-board-label">Movimentações da minha lista</div>
    <div class="gift-board-cards">
      <GiftBoardCard
        label="Valor em presentes recebidos"
        color="#e1f1f5"
        :value="giftsListSummary.gifts_amount"
        :quantity="giftsListSummary.gifts_count"
        :icon="ReceivedGift"
        infoText="Valor e quantidade total de presentes recebidos."
      />
      <GiftBoardCard
        label="Aguardando liberação"
        color="#e1f1f5"
        :value="giftsListSummary.gifts_amount_to_receive"
        :icon="LiberationGift"
        infoText="Valor total aguardando liberação na Carteira."
      />
      <GiftBoardCard
        label="Saldo disponível na Carteira"
        color="#e1f1f5"
        :value="walletSummary.balance"
        :icon="BalanceGift"
        infoText="Valor total disponível para uso na Carteira."
        :walletDetails="true"
        :walletIncomplete="!walletDetails?.has_wallet_owner || false"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GiftBoardCard from '@/components/Gift/GiftBoardCard.vue'
import ReceivedGift from '@/assets/img/received-gift.svg'
import LiberationGift from '@/assets/img/liberation-gift.svg'
import BalanceGift from '@/assets/img/balance-gift.svg'
import GiftsApi from '@/lib/api/Gifts'
import WalletApi from '@/lib/api/Wallet'

export default {
  data() {
    return {
      ReceivedGift,
      LiberationGift,
      BalanceGift,
      giftsListSummary: {},
    }
  },

  created() {
    this.getGiftsSummary()
    this.getWalletSummary()
  },

  components: {
    GiftBoardCard,
  },

  computed: {
    ...mapGetters({
      logonToken: 'app/logonToken',
      walletDetails: 'getWalletDetails',
    }),

    walletSummary: {
      get() {
        return this.$store.state.wallet.walletSummary
      },
      set(payload) {
        this.$store.dispatch('setWalletSummary', payload)
      },
    },
  },

  methods: {
    getGiftsSummary() {
      const giftsApi = new GiftsApi(this.logonToken)
      giftsApi
        .getGiftsSummary()
        .then((response) => {
          this.giftsListSummary = response.data
        })
        .catch((error) => console.error(error))
    },

    getWalletSummary() {
      if (this.walletSummary.loading) {
        const wallet = new WalletApi(this.logonToken)
        wallet.getSummary().then((walletSummary) => {
          this.walletSummary = walletSummary
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.gift-board {
  margin-top: 40px;
}
.gift-board-label {
  text-align: left;
  font-size: 16px;
  font-weight: 700;
  color: $neutraldarkest;
  margin-top: 24px;
  margin-left: 8px;
  justify-content: space-between;
  display: flex;
  margin-bottom: 19px;
}

.gift-board-cards {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  overflow: auto;
}

// hide scrollbar for chrome
.gift-board-cards::-webkit-scrollbar {
  width: 0 !important;
}

// hide scrollbar for firefox
.gift-board-cards {
  scrollbar-width: none;
}
</style>
